import Link from 'next/link'
import PropTypes from 'prop-types'

// Internal components
import Svg from '../Svg/Svg'

const Footer = (props) => {
  const { footerLinks, socialLinks, copyright, termsOfService } = props

  return (
    <footer className="Footer">
      <div className="Footer-container">
        {footerLinks &&
          footerLinks.map(({ heading, links }, index) => {
            return (
              <div className="Footer-item" key={`Footer-item-${index}`}>
                <span className="Footer-title">{heading}</span>
                <ul className="Footer-list">
                  {links.map(({ label, linkItem }, index) => {
                    const {
                      target,
                      url,
                      uri
                    } = linkItem
                    return linkItem.type === 'entry' ? (
                      <li className="Footer-listItem" key={`Footer-listItem-${index}`}>
                        <Link href={`/${uri}`}>
                          <a className="Footer-listLink">
                            <span className="Footer-linkText">{label}</span>
                          </a>
                        </Link>
                      </li>
                    ) : (
                      <li className="Footer-listItem" key={`Footer-listItem-${index}`}>
                        <a href={url} className="Footer-listLink" target={target}>
                          <span className="Footer-linkText">{label}</span>
                        </a>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )
          })}
        {socialLinks &&
          socialLinks.map(({ heading, links }, index) => {
            return (
              <div className="Footer-item" key={`Footer-item-${index}`}>
                <span className="Footer-title">{heading}</span>
                <ul className="Footer-list Footer-list--social">
                  {links &&
                    links.map(({ socialType, socialLink }, index) => {
                      return (
                        <li className="Footer-listItemSocial" key={`Footer-listItemSocial-${index}`}>
                          <a href={socialLink} className="Footer-listLink" target="_blank" rel="noreferrer">
                            <Svg
                              id={`logo-${socialType.toLowerCase()}`}
                              modifiers={[`Footer-linkIcon Footer-linkIcon--${socialType.toLowerCase()}`]}
                            />
                          </a>
                        </li>
                      )
                    })}
                </ul>
              </div>
            )
          })}
      </div>
      <div className="Footer-bar">
        <div className="Footer-contentContainer">
          {copyright && (
            <div className="Footer-barContainer">
              <span className="Footer-barLabel">{copyright}</span>
            </div>
          )}
          {termsOfService && termsOfService.length > 0 && (
            <div className="Footer-barContainer Footer-barContainer--grey">
              <a className="Footer-barLink" href={termsOfService[0].uri}>
                {termsOfService[0].title}
              </a>
            </div>
          )}
        </div>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  footerLinks: PropTypes.array.isRequired,
  socialLinks: PropTypes.array.isRequired,
  termsOfService: PropTypes.array.isRequired,
  copyright: PropTypes.string
}

export default Footer
